// extracted by mini-css-extract-plugin
export default {"item":"NoteExpertDecision_item__HNz76","title":"NoteExpertDecision_title__sMXNN","text":"NoteExpertDecision_text__RVLVu","button":"NoteExpertDecision_button__Rc7iB"};